import { atom } from 'recoil';
// types
import { contactInformationType } from '../types';

export const contactInformationAtom = atom<contactInformationType>({
  key: 'contactInformation',
  default: { profileId: '', showContactInformation: false, isLoading: false },
});
